import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { cn } from "@/lib/utils";

export function ProductCombobox({ products, value, onChange, placeholder = "Seleziona materiale dal magazzino", testid }) {
  const [open, setOpen] = useState(false);
  const cur = products.find((p) => p.product_id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" className="w-full justify-between font-normal" data-testid={testid}>
          <span className="truncate">{cur ? `${cur.manufacturer_code || cur.sku} · ${cur.name}` : placeholder}</span>
          <ChevronsUpDown size={16} className="ml-2 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] p-0" align="start">
        <Command>
          <CommandInput placeholder="Cerca per nome, codice, fornitore..." data-testid={testid ? `${testid}-search` : undefined} />
          <CommandList>
            <CommandEmpty>Nessun materiale trovato</CommandEmpty>
            <CommandGroup>
              {products.map((p) => (
                <CommandItem
                  key={p.product_id}
                  value={`${p.name} ${p.sku || ""} ${p.manufacturer_code || ""} ${p.supplier_name || ""}`}
                  onSelect={() => { onChange(p.product_id); setOpen(false); }}
                  data-testid={`product-option-${p.product_id}`}
                >
                  <Check size={14} className={cn("mr-2 shrink-0", value === p.product_id ? "opacity-100" : "opacity-0")} />
                  <div className="min-w-0">
                    <p className="truncate text-sm font-medium text-navy">{p.name}</p>
                    <p className="truncate text-xs text-muted-foreground">SKU: {p.sku || "—"} · Cod. produttore: {p.manufacturer_code || "—"} · Fornitore: {p.supplier_name || "—"}{p.qty != null ? ` · ${p.qty} ${p.unit || ""}` : ""}</p>
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
